export default "__VITE_ASSET__DlFpIrm7__"